export default "__VITE_ASSET__CgsevQc2__"